import { render, staticRenderFns } from "./Holder.vue?vue&type=template&id=95ce61ec&"
import script from "./Holder.vue?vue&type=script&lang=js&"
export * from "./Holder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports